import { Divider } from '@mui/material'

import { AdditionalInformation } from './fields/AdditionalInformation'
import { Address } from './fields/Address'
import { ContactInformation } from './fields/ContactInformation'
import { Duration } from './fields/Duration'
import { TimeWindowExceptions } from './fields/TimeWindowExceptions'
import { TimeWindows } from './fields/TimeWindows'

import { Props } from './typings'

export const OrderStep = (props: Props) => {
  return (
    <>
      <Address {...props} />
      <ContactInformation {...props} />
      <Divider />
      <Duration {...props} />
      <TimeWindows {...props} />
      <TimeWindowExceptions {...props} />
      <Divider />
      <AdditionalInformation {...props} />
    </>
  )
}
